import { render, staticRenderFns } from "./sponsored.vue?vue&type=template&id=51cfc63b"
import script from "./sponsored.vue?vue&type=script&lang=js"
export * from "./sponsored.vue?vue&type=script&lang=js"
import style0 from "./sponsored.vue?vue&type=style&index=0&id=51cfc63b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports